//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { memo } from "react";

const EditorButton = memo<{
  title: string;
  isActive: boolean;
  isMailDetail?:boolean | undefined;
  onClick: () => void;
  icon: React.ReactNode;
}>(({ title, isActive, onClick, icon,isMailDetail }) => (
  <button
    type="button"
    title={title}
    onClick={onClick}
    className={tw`focus:outline-none rounded-md border transition font-medium ${isMailDetail?"":"p-2"} ${
      isActive
        ? "bg-red-200 text-red-700 border-red-300 shadow-sm"
        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
    }`}
    aria-pressed={isActive}
  >
    {icon}
  </button>
));

EditorButton.displayName = "EditorButton";

export { EditorButton };